<template>
  <div>
    <h2 class="section-title">{{ t('assignedJobs.title') }}</h2>

      <div v-if="loading" class="loading">{{ t('loading') }}</div>

      <div v-else class="table-wrapper">
        <table class="job-table">
          <thead>
            <tr>
              <th>{{ t('jobCode') }}</th>
              <th>{{ t('file') }}</th>
              <th>{{ t('desc') }}</th>
              <th>{{ t('deliveryDate') }}</th>
              <th>{{ t('outputFile') }}</th>
              <th>{{ t('uploadTime') }}</th>
              <th>{{ t('customer') }}</th>
              <th>{{ t('actions') }}</th>
              <th>{{ t('specialization') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="job in assignedJobs"
              :key="job.id"
              @click="openJobDetail(job)"
              style="cursor: pointer"
            >
              <td>{{ formatJobCode(job.id) }}</td>
              <td>
                <a
                  :href="`${API_URL}/uploads/${encodeURIComponent(job.file_name)}`"
                  target="_blank"
                  @click.stop
                >
                  {{ extractOriginalFileName(job.file_name) }}
                </a>
              </td>
              <td>{{ job.description || '-' }}</td>
              <td>{{ formatDate(job.delivery_date) }}</td>
              <td>
                <div v-if="job.output_files.length">
                  <ul>
                    <li v-for="file in job.output_files" :key="file">
                      <a
                        :href="`${API_URL}/uploads/output/${encodeURIComponent(file)}`"
                        target="_blank"
                        @click.stop
                      >
                        {{ extractOriginalFileName(file) }}
                      </a>
                      <button
                        class="btn small danger"
                        @click.stop="deleteOutputFile(job.id, file)"
                      >
                        {{ t('delete') }}
                      </button>
                    </li>
                  </ul>
                </div>
                <div v-else>{{ t('noOutputYet') }}</div>
              </td>
              <td>{{ formatDate(job.output_upload_date) || '-' }}</td>
              <td>{{ job.user_name }} {{ job.user_surname }}</td>
              <td @click.stop>
                <input
                  type="file"
                  multiple
                  :ref="el => fileInputs[job.id] = el"
                  style="display: none"
                  @change="uploadEditedOutput(job.id)"
                />
                <button class="btn small" @click="editOutput(job.id)">
                  {{ t('edit') }}
                </button>
                <button
                  class="btn small green"
                  :disabled="!job.output_files.length"
                  @click="completeJob(job.id)"
                >
                  {{ t('completeJob') }}
                </button>
              </td>
              <td>{{ job.specialization || '-' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
              <!-- Mobil kart görünüm -->
        <div class="mobile-job-cards">
          <div
            class="mobile-card"
            v-for="job in assignedJobs"
            :key="'card-' + job.id"
            @click="openJobDetail(job)"
          >
            <p><strong>{{ t('jobCode') }}:</strong> {{ formatJobCode(job.id) }}</p>
            <p>
              <strong>{{ t('file') }}:</strong>
              <a
                :href="`${API_URL}/uploads/${encodeURIComponent(job.file_name)}`"
                target="_blank"
                @click.stop
              >
                {{ extractOriginalFileName(job.file_name) }}
              </a>
            </p>
            <p><strong>{{ t('desc') }}:</strong> {{ job.description || '-' }}</p>
            <p><strong>{{ t('deliveryDate') }}:</strong> {{ formatDate(job.delivery_date) }}</p>
            <p>
              <strong>{{ t('outputFile') }}:</strong>
              <template v-if="job.output_files.length">
                <ul>
                  <li v-for="file in job.output_files" :key="file">
                    <a
                      :href="`${API_URL}/uploads/output/${encodeURIComponent(file)}`"
                      target="_blank"
                      @click.stop
                    >
                      {{ extractOriginalFileName(file) }}
                    </a>
                    <button
                      class="btn small danger"
                      @click.stop="deleteOutputFile(job.id, file)"
                    >
                      {{ t('delete') }}
                    </button>
                  </li>
                </ul>
              </template>
              <span v-else>{{ t('noOutputYet') }}</span>
            </p>
            <p><strong>{{ t('uploadTime') }}:</strong> {{ formatDate(job.output_upload_date) || '-' }}</p>
            <p><strong>{{ t('customer') }}:</strong> {{ job.user_name }} {{ job.user_surname }}</p>
            <p><strong>{{ t('specialization') }}:</strong> {{ job.specialization || '-' }}</p>
            <div>
              <input
                type="file"
                multiple
                :ref="el => fileInputs[job.id] = el"
                style="display: none"
                @change="uploadEditedOutput(job.id)"
              />
              <button class="btn small" @click.stop="editOutput(job.id)">
                {{ t('edit') }}
              </button>
              <button
                class="btn small green"
                :disabled="!job.output_files.length"
                @click.stop="completeJob(job.id)"
              >
                {{ t('completeJob') }}
              </button>
            </div>
          </div>
        </div>

    <!-- İş Detayları Modalı -->
    <AssignedJobDetailModal
      v-if="selectedJob"
      :job="selectedJob"
      @close="selectedJob = null"
    />
  </div>
</template>


<script setup>
import { ref, onMounted } from 'vue'
import { getToken } from '@/utils/auth'
import { useI18n } from 'vue-i18n'
import AssignedJobDetailModal from '@/components/AssignedJobDetailModal.vue'
const API_URL = process.env.VUE_APP_API_URL
const selectedJob = ref(null)
const { t } = useI18n()
const assignedJobs = ref([])
const loading = ref(false)
const fileInputs = {}


function openJobDetail(job) {
  console.log('Detay açılıyor:', job)
  selectedJob.value = job
}

function formatJobCode(id) {
  return 'JOB-' + String(id).padStart(6, '0')
}

function formatDate(date) {
  if (!date) return '-'
  const d = new Date(date)
  const day = String(d.getDate()).padStart(2, '0')
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const year = d.getFullYear()
  return `${day}.${month}.${year}`
}

function extractOriginalFileName(filename) {
  if (!filename) return '-'
  return filename.substring(filename.indexOf('-') + 1)
}

async function fetchAssignedJobs() {
  loading.value = true

  try {
    const res = await fetch(`${API_URL}/translator/assigned-jobs`, {
      headers: { Authorization: `Bearer ${getToken()}` }
    })

    if (!res.ok) {
      const errorText = await res.text()
      console.error('API hatası:', res.status, errorText)
      throw new Error(`API hatası: ${res.status}`)
    }

    const data = await res.json()

    if (!Array.isArray(data)) {
      console.error('Beklenen veri bir dizi değil:', data)
      assignedJobs.value = []
      return
    }

    assignedJobs.value = data.sort((a, b) =>
      (a.specialization || '').localeCompare(b.specialization || '')
    )

    if (assignedJobs.value.length > 0) {
      const audio = new Audio('/notification.mp3')
      audio.play().catch(() => {})
    }

  } catch (err) {
    console.error('Veri çekilirken hata oluştu:', err)
    assignedJobs.value = []
  } finally {
    loading.value = false
  }
}

function editOutput(jobId) {
  fileInputs[jobId]?.click()
}

async function uploadEditedOutput(jobId) {
  const files = fileInputs[jobId]?.files
  if (!files || !files.length) return alert('Dosya seçilmedi.')

  const formData = new FormData()
  for (const file of files) {
    formData.append('files', file)
  }

  const res = await fetch(`${API_URL}/translator/job/${jobId}/complete`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${getToken()}` },
    body: formData
  })

  if (res.ok) {
    alert('Çıktı dosyası yüklendi.')
    fetchAssignedJobs()
  } else {
    alert('Yükleme başarısız.')
  }
}

async function completeJob(jobId) {
  const job = assignedJobs.value.find(j => j.id === jobId)
  if (!job || !job.output_files || job.output_files.length === 0) {
    alert(t('uploadBeforeComplete') || 'İşi tamamlamadan önce en az bir çıktı dosyası yüklemelisiniz.')
    return
  }

  const res = await fetch(`${API_URL}/translator/job/${jobId}/mark-complete`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`
    },
    body: JSON.stringify({ job_id: jobId })
  })

  if (res.ok) {
    alert(t('jobCompleted') || 'İş başarıyla tamamlandı.')
    fetchAssignedJobs()
  } else {
    alert(t('jobCompleteFailed') || 'Tamamlama işlemi başarısız.')
  }
}

async function deleteOutputFile(jobId, fileName) {
  const confirmDelete = confirm('Bu dosyayı silmek istediğinize emin misiniz?')
  if (!confirmDelete) return

  const res = await fetch(`${API_URL}/translator/job/${jobId}/delete-output/${encodeURIComponent(fileName)}`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${getToken()}` }
  })

  if (res.ok) {
    alert('Dosya silindi.')
    fetchAssignedJobs()
  } else {
    alert('Silme işlemi başarısız.')
  }
}

onMounted(() => {
  fetchAssignedJobs()
})
</script>


<style scoped>
.section {
  padding: 30px;
  max-width: 1200px;
  margin: auto;
}
.section-title {
  margin-bottom: 20px;
  font-size: 24px;
  font-weight: 600;
  color: #2c3e50;
  text-align: center;
}
.job-table {
  width: 100%;
  border-collapse: collapse;
}
.job-table th, .job-table td {
  padding: 12px;
  border-bottom: 1px solid #ccc;
  text-align: left;
}
.btn.small {
  padding: 6px 10px;
  font-size: 0.8em;
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  margin-bottom: 4px;
}
.btn.small.green {
  background-color: #2ecc71;
  margin-top: 5px;
}
.btn.small.danger {
  background-color: #e74c3c;
  margin-left: 8px;
}
.loading {
  text-align: center;
  font-size: 1.2em;
}
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.modal-content {
  background: white;
  padding: 24px;
  border-radius: 8px;
  width: 90%;
  max-width: 600px;
}
.btn {
  margin-top: 20px;
  padding: 8px 16px;
  background: #3498db;
  color: white;
  border: none;
  border-radius: 6px;
}
.table-wrapper {
  width: 100%;
  overflow-x: auto;
}

.table-wrapper table {
  min-width: 1000px;
}
/* Masaüstü görünüm */
@media (min-width: 768px) {
  .mobile-job-cards {
    display: none;
  }
}
/* Mobil görünüm */
@media (max-width: 767px) {
  .table-wrapper {
    display: none;
  }

  .mobile-job-cards {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 10px;
  }

  .mobile-card {
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
    padding: 16px;
    font-size: 14px;
  }

  .mobile-card p {
    margin: 6px 0;
  }

  .mobile-card ul {
    padding-left: 16px;
  }

  .mobile-card button {
    margin-top: 5px;
  }
}

</style>
